import { FC } from 'react';
import {
  Box,
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import { ReadonlyForm } from 'components/molecules/ReadonlyForm/ReadonlyForm';

type Props = {
  mode: '登録' | '更新';
  loading: boolean;
  isOpen: boolean;
  name: string;
  zeusToken: string;
  hasError: boolean;
  handleClose: () => void;
};

export const ResultModalView: FC<Props> = ({
  mode,
  loading,
  isOpen,
  name,
  zeusToken,
  hasError,
  handleClose,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
    isCentered
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px 40px 0 40px">顧客情報の{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        <Box mt="40px">
          <ReadonlyForm label="顧客名" value={name} />
        </Box>
        {/* ロード中 */}
        {loading ?? <Skeleton h="100px" />}
        {/* 登録失敗 */}
        {!loading && hasError && (
          <Box mt="40px" textAlign="center">
            <Text color="modal.valueColor">登録に失敗しました</Text>
          </Box>
        )}
        {/* 登録成功 */}
        {!loading && !hasError && (
          <>
            <Box mt="40px" textAlign="center">
              <Text color="modal.valueColor">登録が完了しました</Text>
            </Box>
            <Box mt="40px" textAlign="center">
              <Heading as="h5" size="sm">
                Zeus トークン
              </Heading>
              <Box
                mt="10px"
                mx="40px"
                textAlign="center"
                borderBottom="1px"
                borderBottomColor="modal.borderBottomColor"
              >
                <Text fontSize="md" color="modal.valueColor">
                  {zeusToken}
                </Text>
              </Box>
            </Box>
          </>
        )}
      </ModalBody>
      <ModalFooter justifyContent="center" mt="100px" mb="20px">
        <Button
          colorScheme="gray"
          variant="outline"
          mr={3}
          onClick={handleClose}
        >
          閉じる
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
